angular.module('zc.zenclerkS')
  .controller('ZcsSetupController', ZcsSetupController);

ZcsSetupController.$inject = ['$scope', '$state', '$translate', 'Devise', 'ZcsOemService', 'ZcsProject', 'project'];
function ZcsSetupController($scope, $state, $translate, Devise, ZcsOemService, ZcsProject, project) {
  const company = {
    label: $translate.instant('sites.setup.setupController.kaishajouhou'),
    name: 'zenclerkS.project.setup.company',
    class: '',
    requiredProperty: 'user.userinfo_confirmed_at'
  };

  const site = {
    label: $translate.instant('sites.setup.setupController.saito_jouhou'),
    name: 'zenclerkS.project.setup.site',
    class: '',
    requiredProperty: 'project.companyinfo_confirmed_at'
  };

  const pricing = {
    label: $translate.instant('sites.setup.setupController.ryoukin_puran_no'),
    name: 'zenclerkS.project.setup.pricing',
    class: '',
    requiredProperty: 'project.siteinfo_confirmed_at'
  };

  const trackingTag = {
    label: $translate.instant('sites.setup.setupController.torakkingutagu_settei'),
    name: 'zenclerkS.project.setup.trackingTag',
    class: '',
    requiredProperty: 'project.pricing_confirmed_at'
  };

  const conversionTag = {
    label: $translate.instant('sites.setup.setupController.konbaajontagu_settei'),
    name: 'zenclerkS.project.setup.conversionTag',
    class: '',
    requiredProperty: 'project.pricing_confirmed_at'
  };

  const complete = {
    label: $translate.instant('sites.setup.setupController.kanryou'),
    name: 'zenclerkS.project.setup.complete',
    class: '',
    requiredProperty: 'project.pricing_confirmed_at'
  };

  const vm = this;
  vm.project = project;
  vm.user = _.merge({}, Devise.currentUser);
  vm.ZcsOemService = ZcsOemService;

  vm.signOut = Devise.signOut;

  // show the companyinfo & pricing only for non makerepeater oem users
  if(ZcsOemService.get() === 'makerepeater' || vm.project.is_oem) {
    vm.states = [site, trackingTag, conversionTag, complete];
    // So the requirements are also bit different
    trackingTag.requiredProperty = 'project.siteinfo_confirmed_at';
  } else if(vm.project.integrated_with === 'color_me_shop') {
    // Hide:
    // - pricing, because color me shop users pay up front at the zcs app installation page
    // - trackingTag, because it's set automatically by our code.
    // - conversionTag, because it's set automatically by our code.
    trackingTag.requiredProperty = 'project.siteinfo_confirmed_at';
    vm.states = [company, site, complete];
  } else if(vm.project.integrated_with === 'shopify') {
    // Hide:
    // - pricing, because shopify users pay up front at the zcs app installation page
    // - trackingTag, because it's automatically set by our code.
    trackingTag.requiredProperty = 'project.siteinfo_confirmed_at';
    vm.states = [company, site, conversionTag, complete];
  } else if(vm.project.fixed_invoice_amount != null || vm.project.fixed_invoice_amount > 0) {
    vm.states = [company, site, trackingTag, conversionTag, complete];
  } else {
    vm.states = [company, site, pricing, trackingTag, conversionTag, complete];
  }

  // actions
  vm.nextStep = nextStep;
  vm.isActiveState = isActiveState;
  vm.isDisabledState = isDisabledState;
  vm.isPreviousState = isPreviousState;
  vm.goToState = goToState;
  vm.isAllowedToReturnToMain = isAllowedToReturnToMain;

  activate();

  function activate() {
    // forward to segment if accessed directly
    if($state.current.name === 'zenclerkS.project.setup') {
      $state.go('zenclerkS.project.setup.company');
    } else {
      let currentState = _.find(vm.states, d => d.name === $state.current.name);
      // if current state is disabled, go to previous
      if(currentState && isDisabledState(currentState)) {
        let prevStateIndex = _.findIndex(vm.states, d => d === currentState) - 1;
        $state.go(vm.states[prevStateIndex].name);
      }
    }

    $scope.$on('siteSetup.nextStep', ev => {
      // get the latest user in case it has been updated
      vm.user = _.merge({}, Devise.currentUser);
      ZcsProject.get(vm.user.id, vm.project.apikey)
        .then(result => {
          vm.project = _.merge(vm.project, result);
          nextStep();
        });
    });
  }

  function isAllowedToReturnToMain() {
    if(vm.user.role === 'master' || vm.user.agency_id) return true;
    if(vm.user.userinfo_confirmed_at &&
      vm.project.companyinfo_confirmed_at &&
      vm.project.siteinfo_confirmed_at &&
      vm.project.pricing_confirmed_at &&
      vm.project.tracking_tag_confirmed_at &&
      vm.project.conversion_tag_confirmed_at) {
      return true;
    }

    return false;
  }

  function isDisabledState(state) {
    if(state.requiredProperty) {
      if(!_.get(vm, state.requiredProperty)) {
        return true;
      }
    }
    return false;
  }

  function isActiveState(state) {
    return $state.current.name === state.name;
  }

  /* Used to add css class that helps styling */
  function isPreviousState(state) {
    let currentStateIndex = _.findIndex(vm.states, { name: state.name });
    let activeStateIndex = _.findIndex(vm.states, { name: $state.current.name });
    return currentStateIndex < activeStateIndex;
  }

  function goToState(state) {
    if(!isDisabledState(state)) {
      // use reload so that the data (updated project) won't be cached
      $state.go(state.name, { apikey: vm.project.apikey }, { reload: true });
    }
  }

  function nextStep(state) {
    let currentStateIndex = _.findIndex(vm.states, { name: $state.current.name });
    // do nothing if last state
    if(currentStateIndex < vm.states.length) {
      // use reload so that the data (updated project) won't be cached
      $state.go(vm.states[currentStateIndex + 1].name, { apikey: vm.project.apikey });
    }
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/setup/setup.controller.js